module.exports = __webpack_public_path__ + "img/zmoabg.0d7e0b91.png";